import React from 'react';
import Hero from '../components/home/Hero';
import FeaturedDestinations from '../components/home/FeaturedDestinations';
import SpecialOffers from '../components/home/SpecialOffers';
import TravelTips from '../components/home/TravelTips';
const Home = () => {
  return <div className="bg-white w-full" data-id="element-992">
      <Hero data-id="element-993" />
      <FeaturedDestinations data-id="element-994" />
      <SpecialOffers data-id="element-995" />
      <TravelTips data-id="element-996" />
    </div>;
};
export default Home;